import { gql } from "@apollo/client";

export const CREATE_USER_MUTATION = gql`
  mutation createUserClient($user: UserClientInput) {
    createUserClient(user: $user)
  }
`;
